import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Button } from './ui/Button';
export function CtaBlock() {
  return <section id="contact" className="py-24 md:py-32" data-id="element-97">
      <div className="container mx-auto px-6 md:px-12" data-id="element-98">
        <SectionReveal data-id="element-99">
          <div className="bg-accent rounded-3xl p-12 md:p-20 text-center relative overflow-hidden" data-id="element-100">
            {/* Dark overlay for contrast */}
            <div className="absolute inset-0 bg-base/90 mix-blend-multiply" data-id="element-101" />

            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-102">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-6 text-primary tracking-tight text-balance" data-id="element-103">
                Ready to optimize your engineering organization?
              </h2>
              <p className="text-lg md:text-xl text-primary/80 mb-10 max-w-2xl mx-auto text-balance" data-id="element-104">
                Schedule a strategic consultation to discuss your current
                bottlenecks, team topology, and how we can align your
                engineering execution with your business goals.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-105">
                <Button size="lg" onClick={() => window.open('https://calendly.com/alexcircei/advising', '_blank')} className="w-full sm:w-auto bg-primary text-base hover:bg-primary/90" data-id="element-106">
                  Schedule a consultation →
                </Button>
                <a href="mailto:alex.circei@gmail.com" className="text-sm text-primary/80 hover:text-primary transition-colors mt-4 sm:mt-0 sm:ml-4 underline-offset-4 hover:underline" data-id="element-107">
                  or contact my office directly
                </a>
              </div>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>;
}